import { GridColumnDefs } from "../../../models/Grid/gridColumnDefs";
import { useEffect, useState } from "react";
import { userManagement_LABELS } from "../../../constants/labels/UserManagement";
import { useLazyGetAllCommunicationLogsQuery } from "../../../services/rtkQueryServices/communicationLogsService";
import MultiSelectDropdown from "../../shared/MultiSelectDropdown/MultiSelectDropdown";
import { Button } from "@mui/material";
import { ReactComponent as Apply } from "../../../assets/svg/Apply.svg";
import { ReactComponent as Reset } from "../../../assets/svg/reset.svg";
import { ReactComponent as ResendIcon } from "../../../assets/svg/Resend.svg";
import { useNavigate } from "react-router-dom";
import { communicationLogs_LABELS } from "../../../constants/labels/CommunicationLogs";
import DaterangePicker from "../../shared/DaterangePicker/DaterangePicker";
import ResendForm from "../ResendForm/ResendForm";
import Grid from "../../shared/Grid/Grid";
import Modal from "../../shared/Modal/Modal";
import CommunicationLogsHistoryGrid from "./CommunicationLogsHistoryGrid/CommunicationLogsHistoryGrid";
import { useGetAllClinicNamesQuery } from "../../../services/rtkQueryServices/clinicService";
import { COMMUNICATION_TYPE } from "../../../constants/enums/communicationTypes";
import { USER_TYPE } from "../../../constants/enums/userTypes";
import { DELIVERY_STATUS_TYPE } from "../../../constants/enums/deliveryStatusTypes";
import { Utility } from "../../../utils/Utility";
import "./CommunicationLogsGrid.scss";
import { CommunicationLogsResponse } from "../../../models/response/communicationLogsResponse";
import { type GetAllCommunicationLogsRequest } from "../../../models/request/getAllCommunicationLogsRequest";
import * as dateFns from "date-fns";

function CommunicationLogsGrid() {
  const [rowData, setRowData] = useState<CommunicationLogsResponse[]>([]);
  const [rowcount, setRowCount] = useState<number>(0);
  const [searchString, setSearchString] = useState<string>("");
  const [error, setError] = useState<string>("");
  const getPreviousDate = (daysAgo: number) => {
    const today = new Date();
    today.setDate(today.getDate() - daysAgo);
    return today;
  };
  const [dateRange, setDateRange] = useState<any>([
    getPreviousDate(3),
    new Date(),
  ]);

  const [filterCriteria, setFilterCriteria] =
    useState<GetAllCommunicationLogsRequest>({
      pageNumber: 1,
      pageSize: 10,
      searchString: null,
      sortByColumnName: "createdDate",
      sortOrder: "desc",
      filters: [],
      timezoneOffSet: 0,
      dateRangeCondition: dateRange?.length
        ? {
            fromDate: dateRange[0]?.toLocaleDateString("fr-CA"),
            toDate: dateRange[1]?.toLocaleDateString("fr-CA"),
          }
        : null,
    });
  const [selectedClinicsList, setSelectedClinicsList] = useState<string[]>([]);
  const [statusList, setStatusList] = useState<string[]>([]);
  const [communicationList, setCommunicationList] = useState<string[]>([]);
  const [clinicsDropDownList, setClinicsDropDownList] = useState<any>([]);
  const [openResendModal, setOpenResendModal] = useState<boolean>(false);
  const [openFailedStatusModal, setOpenFailedStatusModal] =
    useState<boolean>(false);
  const [processId, setProcessId] = useState<any>();
  const [isApplyFiltersEnabled, setIsApplyFiltersEnabled] =
    useState<boolean>(false);
  const [enableClear, setEnableClear] = useState<boolean>(false);
  const [logData, setLogData] = useState<any>();
  const [resetPagination, setResetPagination] = useState<boolean>(false);
  const {
    isFetching,
    isSuccess,
    data: clinicNames,
  } = useGetAllClinicNamesQuery({});
  const [communicationLogsData] = useLazyGetAllCommunicationLogsQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess && !isFetching) {
      const resultArray = clinicNames.data.map((item: any) => ({
        clinicId: item?.clinicId?.toString(),
        clinicName: item?.clinicName,
      }));
      setClinicsDropDownList(resultArray);
    }
  }, [clinicNames]);

  const GetCommunicationLogs = () => {
    communicationLogsData(filterCriteria).then((res) => {
      if (res.isSuccess && !res.isLoading) {
        setRowData(res?.data?.data?.listOfCommunicationLogs);
        setRowCount(res?.data?.data?.totalCount);
      }
    });
  };
  useEffect(() => {
    GetCommunicationLogs();
  }, [filterCriteria]);

  const ClinicContent = (props: any) => {
    return (
      <>
        {props?.data?.clinicName ? (
          <div
            className="text-overflow-ellipse"
            title={props?.data?.clinicName}
          >
            {props?.data?.clinicName}
          </div>
        ) : (
          <div className="d-flex gap-5">
            <span
              className="cursor-pointer"
              title="BP Site ID is not validated for this clinic."
            >
              <span className="px-4">—</span>
            </span>
          </div>
        )}
      </>
    );
  };

  const BpSiteIdContent = (props: any) => {
    return (
      <>
        {props?.data?.bpSiteId ? (
          <span>{props?.data?.bpSiteId}</span>
        ) : (
          <span className="font-style-italic alert-info">
            Bp Site Id not validated
          </span>
        )}
      </>
    );
  };
  const DeliveryStatus = (props: any) => {
    return (
      <>
        <div
          className={
            "bold cursor-pointer text-decoration-underline " +
            (props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.Success
              ? "green "
              : props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.Failed
              ? "red "
              : "yellow")
          }
          onClick={() => {
            setProcessId(props?.data?.processId);
            setOpenFailedStatusModal(true);
          }}
        >
          {props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.Queued ||
          props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.InProgress
            ? "In Progress"
            : DELIVERY_STATUS_TYPE[props?.data?.deliveryStatus]}
        </div>
        <Modal
          isOpen={openFailedStatusModal && props.data.processId === processId}
          onClose={() => {
            setOpenFailedStatusModal(false);
            GetCommunicationLogs();
          }}
          title="Communication History"
          modalWidth="70%"
          closeOnOverLayClick={false}
          headerBg="var(--primary-color)"
          closeIconColor={"var(--white)"}
          headerLogo={<></>}
          modalHeaderBottomStyle={{
            borderBottom: "1px solid var(--primary-color)",
          }}
        >
          {openFailedStatusModal && props.data.processId === processId && (
            <CommunicationLogsHistoryGrid data={props?.data} />
          )}
        </Modal>
      </>
    );
  };

  const createdDate = (props: any) => {
    return Utility.ConvertToDateTime(props?.data?.createdAt);
  };
  const CommunicationLogId = (props: any) => {
    return (
      <div title={props?.data?.processId}>
        {props?.data?.processId.slice(0, 5)}
      </div>
    );
  };
  const CommunicationType = (props: any) => {
    return <>{COMMUNICATION_TYPE[props?.data?.type]}</>;
  };
  const RecipientType = (props: any) => {
    return <>{USER_TYPE[props?.data?.userType]}</>;
  };
  const RecipientName = (props: any) => {
    return (
      <div
        title={`${props?.data?.recipientName} ${
          props?.data?.userType === 1 ? "" : `(${props?.data?.speciality})`
        }`}
      >
        {props?.data?.recipientName}
      </div>
    );
  };
  const Actions = (props: any) => {
    const createdAtDate = new Date(props.data?.initialAppLogDate);
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);

    return (
      <div
        title={
          createdAtDate !== undefined && createdAtDate < ninetyDaysAgo
            ? "Cannot Resend Documents."
            : "Resend"
        }
      >
        <Button
          className="cursor-pointer"
          onClick={() => {
            setOpenResendModal(true);
            setLogData(props.data);
          }}
          disabled={createdAtDate < ninetyDaysAgo}
        >
          <ResendIcon stroke="#1f4494" />
        </Button>
      </div>
    );
  };
  const DocumentNames = (props: any) => {
    return (
      <div className="document-names" title={props?.data?.documentNames}>
        {props?.data?.documentNames}
      </div>
    );
  };
  const columnDefs: GridColumnDefs[] = [
    {
      headerName: communicationLogs_LABELS.logId,
      field: "logId",
      cellRenderer: CommunicationLogId,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.communicationType,
      field: "type",
      cellRenderer: CommunicationType,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.clinicName,
      field: "clinicName",
      sortable: true,
      cellRenderer: ClinicContent,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.bpSiteId,
      field: "bpSiteId",
      cellRenderer: BpSiteIdContent,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.finalisedBy,
      field: "finalisedBy",
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.recipientType,
      field: "userType",
      cellRenderer: RecipientType,
      sortable: true,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.recipientName,
      field: "recipientName",
      cellRenderer: RecipientName,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.recipientAddress,
      field: "recipientAddress",
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.documentsSent,
      field: "documentNames",
      cellRenderer: DocumentNames,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.status,
      field: "deliveryStatus",
      cellRenderer: DeliveryStatus,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.initiatedBy,
      field: "initiatedBy",
      sortable: true,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.date,
      field: "createdDate",
      cellRenderer: createdDate,
      sortable: true,
      align: "center",
    },
    {
      headerName: userManagement_LABELS.actions,
      field: "ACTIONS",
      cellRenderer: Actions,
      align: "center",
    },
  ];
  const onPageChange = (value: number) => {
    setFilterCriteria({
      ...filterCriteria,
      pageNumber: value,
    });
  };
  const onPageSizeChange = (value: number) => {
    setFilterCriteria({
      ...filterCriteria,
      pageNumber: 1,
      pageSize: value,
    });
  };
  const searchResults = (value: string) => {
    setSearchString(value);
    setFilterCriteria({
      ...filterCriteria,
      pageNumber: 1,
      searchString: value?.trim().length > 0 ? value.trim() : null,
    });
  };
  const sordOrder = (columnName: string, order: string) => {
    if (order === "asc" || order === "desc") {
      setFilterCriteria({
        ...filterCriteria,
        pageNumber: 1,
        sortByColumnName: columnName,
        sortOrder: order,
      });
      setResetPagination(true);
    } else {
      setFilterCriteria({
        ...filterCriteria,
        pageNumber: 1,
        sortByColumnName: null,
        sortOrder: null,
      });
      setResetPagination(true);
    }
  };

  return (
    <>
      <ResendForm
        isOpen={openResendModal}
        onClose={() => {
          setOpenResendModal(false);
        }}
        onReload={() => {
          GetCommunicationLogs();
        }}
        logInformation={logData}
      />
      <div className="communication-logs-wrapper clinic-grid-wrapper overflow-auto d-flex flex-column">
        <Grid
          columnDefs={columnDefs}
          resetPagination={resetPagination}
          uniqueIdentifierFieldName="id"
          rowData={rowData}
          serverSidePagination
          rowCount={rowcount}
          serverSideSorting
          showPagination
          showFilterIcon
          pageSizeList={[10, 20, 50]}
          pageSize={10}
          showTotalRowCount
          masterDetail
          isSearch={searchString?.length > 0}
          defaultSortColumn={filterCriteria.sortByColumnName}
          defaultSortOrder={["desc", "asc", "unsorted"]}
          filterTemplate={[
            <>
              <MultiSelectDropdown
                placeholder={"Select Type"}
                canSearch
                searchFilterDropdownPlaceholder={"Communication Type"}
                searchFilterDropdownMenuList={[
                  { communicationTypeName: "Email", communicationTypeId: "1" },
                  { communicationTypeName: "Fax", communicationTypeId: "3" },
                ]}
                displayPropertyName={"communicationTypeName"}
                valuePropertyName={"communicationTypeId"}
                value={communicationList}
                width={"200px"}
                onChange={(val: any) => {
                  setCommunicationList(val);
                  setIsApplyFiltersEnabled(true);
                }}
              />
              <MultiSelectDropdown
                placeholder={"Select Clinic Name"}
                canSearch
                searchFilterDropdownPlaceholder={"Clinic"}
                searchFilterDropdownMenuList={clinicsDropDownList}
                displayPropertyName={"clinicName"}
                valuePropertyName={"clinicId"}
                value={selectedClinicsList || [""]}
                width={"235px"}
                onChange={(val: any) => {
                  setSelectedClinicsList(val);
                  setIsApplyFiltersEnabled(true);
                }}
              />
              <MultiSelectDropdown
                placeholder={"Select Status"}
                searchFilterDropdownPlaceholder={"Status"}
                searchFilterDropdownMenuList={[
                  { statusName: "Success", statusId: "1" },
                  { statusName: "Failed", statusId: "2" },
                  { statusName: "In Progress", statusId: "4" },
                ]}
                displayPropertyName={"statusName"}
                valuePropertyName={"statusId"}
                value={statusList}
                width={"200px"}
                canSearch
                onChange={(val: any) => {
                  setStatusList(val);
                  setIsApplyFiltersEnabled(true);
                }}
              />
              <div>
                <DaterangePicker
                  dateRange={dateRange}
                  // allowedDateRange={allowedDateRange}
                  onChange={(val: any) => {
                    if (val !== null) {
                      var minStartDate = dateFns.startOfDay(
                        dateFns.subDays(new Date(), 90)
                      );
                      var maxEndDate = dateFns.endOfDay(new Date());
                      var startDate = new Date(val[0]);
                      var endDate = new Date(val[1]);
                      if (startDate < minStartDate || endDate > maxEndDate) {
                        setError("Select date range within past 90 days");
                        setIsApplyFiltersEnabled(false);
                      } else {
                        setError("");
                        setIsApplyFiltersEnabled(true);
                      }
                    } else {
                      setError("");
                      setIsApplyFiltersEnabled(true);
                    }
                    setDateRange(val);
                  }}
                  setIsApplyFiltersEnabled={setIsApplyFiltersEnabled}
                />
                {error && (
                  <div
                    style={{
                      paddingLeft: "5px",
                    }}
                    className="error-message"
                  >
                    {error}
                  </div>
                )}
              </div>
              <div className="d-flex pt-2 px-2">
                <Button
                  className={"apply"}
                  disabled={!isApplyFiltersEnabled}
                  onClick={() => {
                    const isInProgress = statusList.includes("4");
                    let updatedStatusList = [...statusList];
                    if (isInProgress) {
                      if (!updatedStatusList.includes("3")) {
                        updatedStatusList.push("3");
                      }
                    } else {
                      updatedStatusList = updatedStatusList.filter(
                        (status) => status !== "3"
                      );
                    }
                    setFilterCriteria({
                      ...filterCriteria,
                      pageNumber: 1,
                      filters: [
                        { fieldName: "clinicId", values: selectedClinicsList },
                        {
                          fieldName: "deliveryStatus",
                          values: updatedStatusList,
                        },
                        { fieldName: "type", values: communicationList },
                      ],
                      dateRangeCondition: dateRange?.length
                        ? {
                            fromDate: dateRange[0]?.toLocaleDateString("fr-CA"),
                            toDate: dateRange[1]?.toLocaleDateString("fr-CA"),
                          }
                        : null,
                      timezoneOffSet: dateRange?.length
                        ? new Date().getTimezoneOffset()
                        : 0,
                    });
                    setEnableClear(true);
                    setIsApplyFiltersEnabled(false);
                    setResetPagination(true);
                  }}
                >
                  <Apply />
                  <span className="px-2">Apply</span>
                </Button>
              </div>
              <div className="d-flex pt-2 px-2">
                <Button
                  className={"reset"}
                  disabled={!enableClear}
                  onClick={() => {
                    var date = [getPreviousDate(3), new Date()];
                    setSelectedClinicsList([]);
                    setCommunicationList([]);
                    setStatusList([]);
                    setDateRange(date);
                    setFilterCriteria({
                      ...filterCriteria,
                      pageNumber: 1,
                      filters: [],
                      dateRangeCondition: {
                        fromDate: date[0].toLocaleDateString("fr-CA"),
                        toDate: date[1].toLocaleDateString("fr-CA"),
                      },
                      timezoneOffSet: 0,
                    });
                    setResetPagination(true);
                    setEnableClear(false);
                    setIsApplyFiltersEnabled(false);
                    setError("");
                  }}
                >
                  <Reset />
                  <span className="px-2">Reset</span>
                </Button>
              </div>
            </>,
          ]}
          canSearch
          resetSuccess={() => {
            setResetPagination(false);
          }}
          setSearchQuery={(values: string) => {
            searchResults(values);
            setResetPagination(true);
          }}
          clearSearch={() => {
            if (
              filterCriteria?.searchString &&
              filterCriteria?.searchString?.length >= 3
            ) {
              searchResults("");
              setResetPagination(true);
            }
          }}
          sortBy={(columnName: string, order: string) => {
            sordOrder(columnName, order);
          }}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          searchFieldName=""
        />
      </div>
    </>
  );
}

export default CommunicationLogsGrid;
